export default function updateFeaturePicture(newImageList, currentFeatureImage) {
  if (!newImageList) return '';
  if (newImageList.length > 0) {
    if (newImageList.includes(currentFeatureImage)) return currentFeatureImage;
    return newImageList[0];
  }
  return '';
}
